import { useEffect, useState } from 'react';
import { formatCurrency } from '../../utils/currency';

interface CurrencyInputProps {
  id?: string;
  value: number;
  onChange: (v: number) => void;
}

export function CurrencyInput({ id, value, onChange }: CurrencyInputProps) {
  const [display, setDisplay] = useState(() => (value > 0 ? formatCurrency(value) : ''));

  useEffect(() => {
    const current = parseInt(display.replace(/\D/g, '') || '0', 10) / 100;
    if (Math.abs(current - value) > 0.001) {
      setDisplay(value > 0 ? formatCurrency(value) : '');
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '');
    const numeric = parseInt(digits || '0', 10) / 100;
    setDisplay(numeric > 0 ? formatCurrency(numeric) : '');
    onChange(numeric);
  };

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={display}
      onChange={handleChange}
      placeholder="R$ 0,00"
      className="w-full px-3 py-2.5 rounded-lg border border-champagne-dark text-text-dark placeholder-text-light bg-white text-base focus:outline-none focus:ring-2 focus:ring-chocolate/20 focus:border-chocolate"
    />
  );
}
